// Purpose: Sign in with Apple via native bridge on iOS WebView vs web OAuth redirect elsewhere.
// Mistake: routing Android in-app Apple through native bridge fails; use auth redirect like mobile Safari.
// Mistake: isInApp() false before bridge inject; use isAppWebViewContext so iOS WebView always hits native Apple first.
// Mistake: web Apple OAuth waited long app-context detection timeout; use quick probe at button-click path.
import { getLanguageValue } from "locales/i18n";
import { PAGE_TYPE } from "enums";
import { getIsIos, isAppWebViewContextQuick } from "./InApp.helper";
import { requestNativeSocialLogin } from "./SocialBridge.helper";

export type AppleOAuthFlow = "login" | "signup";

export async function executeAppleOAuth(opts: {
    flow: AppleOAuthFlow;
    authBase: string;
    locationSearch: string;
    onNativeBridgeError: (message: string) => void;
}): Promise<void> {
    const { flow, authBase, locationSearch, onNativeBridgeError } = opts;
    const trimmedAuthBase = authBase.replace(/\/+$/, "");
    const q = locationSearch || "";

    if (await isAppWebViewContextQuick()) {
        const isIos = await getIsIos();
        if (isIos) {
            const result = await requestNativeSocialLogin("apple", flow);
            if (result && !result.ok && result.errorCode !== "CANCELLED") {
                onNativeBridgeError(
                    result.message ||
                        getLanguageValue(PAGE_TYPE.COMMON, "studentSignupPre.oauthNotReady"),
                );
            }
            return;
        }
        if (!trimmedAuthBase) {
            onNativeBridgeError(getLanguageValue(PAGE_TYPE.COMMON, "studentSignupPre.oauthNotReady"));
            return;
        }
        window.location.href = `${trimmedAuthBase}/auth/social-redirect/apple${q}`;
        return;
    }

    if (!trimmedAuthBase) {
        onNativeBridgeError(getLanguageValue(PAGE_TYPE.COMMON, "studentSignupPre.oauthNotReady"));
        return;
    }
    window.location.href = `${trimmedAuthBase}/auth/social-redirect/apple${q}`;
}
